<mat-dialog-content>
  <p>La suppression de vos données signifie que toutes les informations associées à votre compte seront définitivement.</p>
  <p>Cela inclut [liste des données à supprimer, par exemple : historique des transactions, informations personnelles, etc.].</p>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-end">
  <button mat-button (click)="onNoClick()" cdkFocusInitial>Annuler</button>
  <button mat-flat-button color="warn" [mat-dialog-close]="'true'">Supprimer</button>
</mat-dialog-actions>
